import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["exact", "strict"];
import { Tab } from 'foundations-components/transitional/components/Tabs';
import AbstractRouterLink from './internal/AbstractRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
const RouterTab = props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({}, rest, {
    component: Tab
  }));
};
export default RouterTab;